import { render, staticRenderFns } from "./DefaultCaption.vue?vue&type=template&id=c9c82ec6&scoped=true&"
import script from "./DefaultCaption.vue?vue&type=script&lang=js&"
export * from "./DefaultCaption.vue?vue&type=script&lang=js&"
import style0 from "./DefaultCaption.vue?vue&type=style&index=0&id=c9c82ec6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c82ec6",
  null
  
)

export default component.exports